<template>
	<!-- <div :style="{width: width + 'px'}" class="excelBox"> -->
	<div class="excelBox">
		<table ref='tableRef' class="table_AgKOv" :style="{'--cow--width': cowWidth + 'px'}">
			<tr ref='inputTr' v-for="(item, index) in table_list" :key="index">
				<template v-for="(data, da_index) in item">
					<td ref='inputTd' class="label_3bK48" :key="da_index" v-if="data.type == 'label'"
						:colspan="data.colspan" :rowspan="data.rowspan">
						<div v-html="data.value" :style="data.style ? data.style : {}" v-if="!data.fun"
							:class="data.class ? data.class : ''">
						</div>
						<div v-else :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
							{{data.fun(form,item,index,da_index,data)}}
						</div>
					</td>
					<!-- 输入框 -->
					<td ref='inputTd' class="value_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'input'">
						<a-form-item :class="`form_item_input_${index}_${da_index}`" style='d'>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<a-input ref='inputRef' @keydown="handleKeydown($event, index,da_index)"
									:style="data.field=='line_id'?'flex:1;':''"
									@change="inputChage($event,form,item,index,data,da_index)" v-decorator="[`${filed}_input_${index}_${da_index}`, { 
                                                    initialValue: data.value,
                                                    rules: data.rules || []
                                                }]" placeholder="请输入" />
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 禁用的输入框 -->
					<td ref='inputTd' class="value_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'disInput'">
						<a-form-item :class="`form_item_disInput_${index}_${da_index}`">
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before">{{ data.before }}</span>
								<a-input ref='inputRef' @keydown="handleKeydown($event, index,da_index)"
									@change="inputChage($event,form,item,index,data,da_index)" disabled v-decorator="[`${filed}_disInput_${index}_${da_index}`, { 
                                                    initialValue: data.value,
                                                    rules: data.rules || []
                                                }]" placeholder="自动计算" />
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 数字输入框 -->
					<td ref='inputTd' class="value_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'number'">
						<a-form-item :class="`form_item_number_${index}_${da_index}`">
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<a-input-number ref='inputRef' @keydown="handleKeydown($event, index,da_index)"
									@change="numberChaneg($event,item,index,data,da_index)" v-decorator="[`${filed}_input_number_${index}_${da_index}`, { 
                                                    initialValue: data.value,
                                                    rules: data.rules || []
                                                }]" placeholder="请输入" />
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 文本域 -->
					<td ref='inputTd' class="value_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'textarea'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<a-textarea ref='inputRef' @keydown="handleKeydown($event, index,da_index)" v-decorator="[`${filed}_textarea_${index}_${da_index}`, { 
                                                    initialValue: data.value,
                                                    rules: data.rules || []
                                                }]" :rows="data.rows ? data.rows : 1" placeholder="请输入" />
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<td ref='inputTd' class="value_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'range_time'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<a-range-picker ref='inputRef' @keydown="handleKeydown($event, index,da_index)" v-else
									style='min-width:100%' :show-time="data.showtime?{ format: 'HH:mm' }:null"
									v-decorator="[`${filed}_range_time_${index}_${da_index}`, {
								                        initialValue: data.value,
								                        rules: data.rules || []
													
								                    }]" :valueFormat="data.showtime?'YYYYMMDD HH:mm':'YYYYMMDD'"
									:format="data.showtime?'YYYYMMDD HH:mm':'YYYYMMDD'" />
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>

					<!-- 时间选择框 -->
					<td ref='inputTd' class="value_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'time'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<!-- 需要别的类型可以自己加 -->
								<span v-if="data.before">{{ data.before }}</span>
								<a-time-picker ref='inputRef' @keydown="handleKeydown($event, index,da_index)"
									:default-open-value="moment('00:00', 'HH:mm')" :show-time="{ format: 'HH:mm' }"
									v-if='data.showtime' style='width:100%;max-width:100%' v-decorator="[`${filed}_time_${index}_${da_index}`, { 
                                                        initialValue: data.value,
                                                        rules: data.rules || []
                                                    }]" format="HH:mm" />

								<a-date-picker ref='inputRef' @keydown="handleKeydown($event, index,da_index)"
									:show-time='data.dateshowtime' v-else style='min-width:70%' v-decorator="[`${filed}_time_${index}_${da_index}`, { 
                                                        initialValue: data.value,
                                                        rules: data.rules || []
                                                    }]"
									:valueFormat="data.dateshowtime?'YYYY-MM-DD HH:mm':'YYYY-MM-DD'"
									:format="data.dateshowtime?'YYYY-MM-DD HH:mm':'YYYY-MM-DD'" />
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 单选下拉框 -->
					<td ref='inputTd' class="value_1DtKU select_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'select'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>

								<a-select ref='inputRef' @keydown="handleKeydown($event, index,da_index)"
									:style="data.field=='line_id'?'flex:1;':''"
									@change='changeSelect($event,form,item,index,data,da_index)' v-decorator="[`${filed}_select_${index}_${da_index}`, { 
                                                                    initialValue: data.value,
                                                                    rules: data.rules || []
                                                                    }]" :filter-option="filterOption" show-search
									placeholder="请选择" :options="data.list">
								</a-select>
							</div>
						</a-form-item>
					</td>
					<!-- 单选框 -->
					<td ref='inputTd' class="value_1DtKU select_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'radio'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<!-- 需要别的类型可以自己加 -->
								<span v-if="data.before">{{ data.before }}</span>

								<a-checkbox ref='inputRef' @keydown="handleKeydown($event, index,da_index)" v-decorator="[`${filed}_radio_${index}_${da_index}`, { 
                                    initialValue: data.value,
                                    rules: data.rules || []
                                }]">
								</a-checkbox>
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 单选框2 -->
					<td ref='inputTd' class="value_1DtKU select_1DtKU" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'radio2'">
						<a-form-item>
							<div class="radio_square" :style="data.style ? data.style : {}"
								:class="data.class ? data.class : ''">
								<!-- 需要别的类型可以自己加 -->
								<span v-if="data.before">{{ data.before }}</span>
								<a-radio-group ref='inputRef' @keydown="handleKeydown($event, index,da_index)"
									v-decorator="[`${filed}_radio_${index}_${da_index}`, { 
                                        initialValue: data.value,
                                        rules: data.rules || []
                                    }]">
									<a-radio v-for="(op,opindex) in data.list" :key="opindex" :value="op.value">
										{{op.label}}
									</a-radio>
								</a-radio-group>
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 对角线 -->
					<!--  direction: 'bottom-right' // 可选值: 'bottom-right'(默认), 'top-right', 'bottom-left' -->
					<td ref='inputTd' class="value_1DtKU diagonal-cell" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'diagonal'">
						<div class="diagonal-wrapper">
							<div class="diagonal-content" :class="data.direction || 'bottom-right'" :data-index="index"
								:data-da-index="da_index">
								<span class="diagonal-text topLeft">{{ data.topLeftText || data.title }}</span>
								<span
									class="diagonal-text bottomRight">{{ data.bottomRightText || data.subtitle }}</span>
							</div>
						</div>
					</td>
					<!-- 嵌套table -->
					<td ref='inputTd' class="value_1DtKU nested-table-cell" style="padding: 0;height:auto;"
						:key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'table'">
						<div style='height:100%;' :class="`nested-table-wrapper_${index}`">
							<excel :table='1' @keydown="handleKeydown($event, index,da_index)" class='excel'
								@add_flag_get='add_flag_get' :add_flag='add_flag' :is_limit='is_limit'
								:p_table='table_list' :cssindex='index' :width="widthHandler(data.colspan)"
								:table_list="data.table_list" :form='form' :is_add="data.is_add? data.is_add : null"
								:filed="'table' + da_index+ index"></excel>
							<div style="page-break-after: always;"></div>
						</div>

					</td>
				</template>
				<div class="add_row_box" v-if="is_add">
					<a-icon :style="{ fontSize: '16px', color: '#1890ff' }" @click="addNesting"
						v-if="(is_add.max && table_list.length < is_add.max || !is_add.max ) && index == table_list.length - 1"
						type="plus-circle" />
					<a-icon :style="{ fontSize: '16px', color: 'red' }" type="minus-circle" v-if="table_list.length > 1"
						@click="removeNesting(index)" />
				</div>
			</tr>
		</table>
	</div>
</template>

<script>
	import moment from 'moment';
	export default {
		name: 'excel',
		props: {
			table_list: {
				type: Array,
				default: () => []
			},
			// 最外层list
			p_table: {
				type: Array,
				default: () => []
			},

			filed: { // 嵌套表格时需要这个来进行校验
				type: String,
				default: ''
			},
			is_add: { // 是否可以新增 max最大新增数量  rawData新增时的数据
				type: [Object, null],
				default: null
			},
			is_limit: {
				type: Number,
				default: 0
			},
			width: {
				type: [Number, String],
				default: 960
			},
			form: {
				type: Object,
				default: () => {}
			},
			template_id: {
				type: [Number, String],
				default: 960
			},

			cssindex: {
				type: Number,
				default: 0
			},
			scale: {
				type: [Number, String],
				default: 1
			},
			can_change: {
				type: [Number, String],
				default: 1
			},
			add_flag: {
				type: [Number, String],
				default: 1
			},

			table: {
				type: [Number, String],
				default: 0
			},

		},
		data() {
			return {

				currentIndex: 0, // 当
				currentIndexBox: 0 // 当
			}
		},
		computed: {
			cowWidth() {
				return (this.scale * this.width / 24).toFixed(5)
			}
		},
		mounted() {
			document.addEventListener('keydown', this.handleKeydown); // 监听键盘事件
			this.$nextTick(() => {
				this.calculateDiagonals();
				this.$refs.inputFields[0].focus();
			});
		},
		updated() {
			this.$nextTick(() => {
				this.calculateDiagonals();
			});
		},
		methods: {
			handleKeyDownSelect(event) {
				event.preventDefault();
				// 或者根据特定键阻止特定操作
				if (event.key === 'ArrowDown') {
					event.preventDefault(); // 阻止下拉箭头键的默认行为
				}
			},
			handleKeydown(event, currentIndex, da_currentIndex) {
				
				const inputs = this.$refs; // 获取所有输入框的引用
				let inputRefs = inputs.inputRef;
				let inputTrs =inputs.inputTr;
				let inputTds = inputs.inputTd;
				console.log(inputTrs)
				
				console.log(inputRefs)
				const currentInputIndex = inputRefs.indexOf(event.target); // 当前输入框的索引
				const currentInputIndexTr = inputTrs.indexOf(event.target); // 当前输入框的索引
				const currentInputIndexTd = inputTds.indexOf(event.target); // 当前输入框的索引
				console.log(currentInputIndex,currentInputIndexTr,currentInputIndexTd)
				// if (event.key === 'ArrowUp' && currentInputIndex > 0) { // 上箭头键，且不是第一个输入框
				// 	inputRefs[currentInputIndex - 1].focus(); // 聚焦上一个输入框
				// } else if (event.key === 'ArrowDown' && currentInputIndex < inputRefs.length - 1) { // 下箭头键，且不是最后一个输入框
				// 	inputRefs[currentInputIndex + 1].focus(); // 聚焦下一个输入框
				// }
			},
			moment,
			add_flag_get(e) {
				this.add_flag = e
			},
			inputChage() {},
			widthHandler(colspan) {
				return (colspan * this.cowWidth).toFixed(5)
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			/**
			 * 为table类型单元格添加内容
			 * 
			 */
			addNesting() {
				let obj = JSON.parse(JSON.stringify(this.is_add.rawData))
				if (this.is_add.add_serial) {
					obj.forEach((d, d_index) => {
						if (d_index == 0) {
							obj[d_index].value = this.table_list.length + 1
						} else {
							if (this.is_add.rawData[d_index].fun) {
								obj[d_index].fun = this.is_add.rawData[d_index].fun
							}
						}
					})
				} else {
					obj.forEach((d, d_index) => {
						if (this.is_add.rawData[d_index].fun) {
							obj[d_index].fun = this.is_add.rawData[d_index].fun
						}
					})
				}
				this.table_list.push(obj)
				// 触发视图更新
				this.$forceUpdate();
			},
			/**
			 * 删除单元格
			 */
			removeNesting(rowIndex) {
				let ind_temp = this.table_list.length - 1
				let arr = this.table_list.splice(rowIndex, 1)[0]

				let _form = this.form.getForm()
				let _form_data = _form.getFieldsValue()

				let temp_obj = {}
				this.table_list.forEach((item, index) => {
					if (index >= rowIndex) {
						item.forEach((key, ind) => {
							if (key.type == 'number') {
								temp_obj[`${this.filed}_input_${key.type}_${index}_${ind}`] = _form_data[
									`${this.filed}_input_${key.type}_${index+1}_${ind}`]
							} else if (key.type != 'label' && key.type != 'disInput') {
								temp_obj[`${this.filed}_${key.type}_${index}_${ind}`] = _form_data[
									`${this.filed}_${key.type}_${index+1}_${ind}`]
							}

						})

					}
				})

				arr.forEach((i, v) => {
					if (i.type == 'number') {
						temp_obj[`${this.filed}_input_${i.type}_${ind_temp}_${v}`] = undefined
					} else if (i.type != 'label' && i.type != 'disInput') {
						temp_obj[`${this.filed}_${i.type}_${ind_temp}_${v}`] = undefined
					}
				})
				this.form.setFieldsValue(temp_obj)

				// 最后一列合并的时候还
				if (rowIndex == 0 && this.is_add.add_index_one) {
					this.table_list[0].push({
						"type": "select",
						"rowspan": 99,
						"colspan": 4,
						"value": null,
						"rules": [{
							"required": true,
							"message": "请选择"
						}],
						"list": [{
								"label": "合格",
								"value": 1
							},
							{
								"label": "不合格",
								"value": 0
							}
						]
					})

				}
				setTimeout(() => {
					if (this.is_add.add_serial) {
						this.table_list.map((it, index) => {
							it[0].value = index + 1
						})
						if (this.is_add.fun) {
							this.is_add.fun(this.form, this.table_list, this.add_flag)
								this.$forceUpdate();
						}
					}else{
							this.$forceUpdate();
						
					}
				
				}, 500)

			},
			calculateDiagonals() {
				// 查找所有对角线单元格
				const diagonalElements = this.$el.querySelectorAll('.diagonal-content');
				diagonalElements.forEach(element => {
					const parentTd = element.closest('td');
					if (!parentTd) return;
					// 获取单元格的实际尺寸
					const rect = parentTd.getBoundingClientRect();
					const width = parentTd.offsetWidth;
					const height = parentTd.offsetHeight;

					// 计算对角线长度和角度
					const diagonalLength = Math.sqrt(width * width + height * height);
					const angle = Math.atan2(height, width) * 180 / Math.PI;

					// 移除之前添加的样式
					const existingStyle = element.querySelector('.diagonal-line');
					if (existingStyle) {
						existingStyle.remove();
					}

					// 创建样式元素
					const styleElement = document.createElement('style');
					const direction = element.classList.contains('top-right') ? 'top-right' :
						element.classList.contains('bottom-left') ? 'bottom-left' : 'bottom-right';

					let transform = '';
					let transformOrigin = '';

					switch (direction) {
						case 'top-right':
							// 从左下到右上
							transform = `rotate(${-angle}deg)`;
							transformOrigin = '0 100%';
							break;
						case 'bottom-left':
							// 从右上到左下
							transform = `rotate(${-angle}deg)`;
							transformOrigin = '100% 100%';
							break;
						case 'bottom-right':
						default:
							// 从左上到右下（默认）
							transform = `rotate(${angle}deg)`;
							transformOrigin = '0 0';
							break;
					}
					let weiz = direction == 'bottom-left' ? 'top: 0;' : direction == 'bottom-right' ?
						'top: 0;' : 'bottom: 0;'
					let weizLeft = direction == 'bottom-left' ? 'left: -5px;' : direction == 'bottom-right' ?
						'left: 0;' : 'left: 0;'
					// 添加伪元素样式
					const uniqueClass = `diagonal-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
					element.classList.add(uniqueClass);
					styleElement.textContent = `
                            .${uniqueClass}::before {
                            content: '';
                            position: absolute;
                            width: ${diagonalLength}px;
                            height: 1px;
                            background-color: #2b2e33;
                            ${weiz}
                            ${weizLeft}
                            transform: ${transform};
                            transform-origin: ${transformOrigin};
                            z-index: 1;
                            }
                        `;
					element.appendChild(styleElement);
				});
			},
			// 输入框变化
			inputChange(e, form, item, index, data, da_index) {
				this.$nextTick(() => {
					data.fun ? data.fun(e, form, item, index, data, da_index) : () => {}
				})
			},
			changeRadio(e, item, index, data, da_index) {


			},
			changeSelect(e, item, index, data, da_index) {
				// 切换模版
				// if (da_index.field == 'goods_name' && this.can_change) {
				// 	this.$emit('goods_name_change', e)
				// }
				// 切换品类的时候要调整计算方式
				if (da_index.field == 'goods_name') {
					let name_code = ''
					this.table_list.forEach(it => {
						it.forEach((i) => {
							if (this.template_id == 29 || this.template_id == 30 || this.template_id ==
								23 || this.template_id == 24 || this.template_id == '21' || this
								.template_id == '22' || this.template_id == 20 || this.template_id ==
								'28' || this.template_id == '27' || this.template_id == '26') {

								da_index.list.forEach(it => {
									if (it.value == e) {
										name_code = it
									}
								})
								this.add_flag = name_code.capacity_unit
								this.$emit('add_flag_get', name_code.capacity_unit)
								if (i.value) {
									if (i.value.includes && i.value.includes('净含量')) {
										i.value = '净含量' + (name_code.capacity_unit == 1 ? '（ML）' : '（L）')
									}
									if (i.value.includes && i.value.includes('毛重')) {
										i.value = '毛重' + (name_code.capacity_unit == 1 ? '（g）' : '（kg）')
									}
								}
								if (da_index.fun) {
									da_index.fun(this.form, this.table_list, this.add_flag)
								}
							}

							if (i.type == 'table') {
								if (this.is_limit) {

									i.table_list.forEach((k) => {
										k.forEach((d, n) => {
											// 扭矩
											if (this.template_id == 29 || this
												.template_id == 30 || this.template_id ==
												23 || this.template_id == 24) {
												if (n == 1) {
													i.is_add.rawData[n].range = {
														max: Number(name_code
															.starting_torque.max),
														min: Number(name_code
															.starting_torque.min)
													}

													d.range = {
														max: Number(name_code
															.starting_torque.max),
														min: Number(name_code
															.starting_torque.min)
													}
												}
												if (n == 2) {
													i.is_add.rawData[n].range = {
														max: Number(name_code
															.breaking_torque.max),
														min: Number(name_code
															.breaking_torque.min)
													}
													d.range = {
														max: Number(name_code
															.breaking_torque.max),
														min: Number(name_code
															.breaking_torque.min)
													}
												}
											}
										})
									})
									this.changeStyle(this.table_list)
								}

							}
						})

					})
					if (this.is_add && this.is_add.fun) {
						this.is_add.fun(this.form, this.table_list, name_code.capacity_unit)
					}
				}


				// 切换工厂时将产线默认值设置
				if (da_index.field == 'factory_id') {
					let fac_code = ''
					da_index.list.forEach(it => {
						if (it.value == e) {
							fac_code = it.factory_code
						}
					})
					this.table_list.forEach(it => {
						it.forEach(i => {
							if (i.type == 'select' && i.field == 'line_id') {
								i.before = `<span style='margin-right: 8px;'>${fac_code}</span>`
								i.style = 'display: flex;align-items: center;'

							}
						})
					})
				}


				// 切换温度时将密度默认值设置
				if (da_index.field == 'temperature') {
					let density = ''
					da_index.list.forEach(it => {
						if (it.value == e) {
							density = it.density
						}
					})
					this.table_list.forEach(it => {
						it.forEach(i => {
							if (i.type == 'disInput' && i.field == 'density') {
								let _form = this.form.getForm()
								let _form_data = _form.getFieldsValue()
								const dynamicMap = new Map();
								i.value = density
								dynamicMap.set('_disInput_4_1', density);
								dynamicMap.set('_disInput_2_3', density);
								const fieldsValue = Object.fromEntries(dynamicMap);
								_form.setFieldsValue(fieldsValue)

							}
						})
					})

					if (da_index.fun) {
						da_index.fun(this.form, this.table_list, this.add_flag)
					}

				}



			},
			// 清除后清除提示
			changeStyleClear(arr) {

				let _form = this.form.getForm()
				let _form_data = _form.getFieldsValue()
				arr.forEach((data, index) => {
					data.forEach((da_data, da_index) => {
						if (da_data.type != 'table') {
							if (da_data.range) {
								document.querySelector(
										`.form_item_${da_data.type}_${index}_${da_index}`)
									.querySelector(
										'.ant-input-number').style = ''
							}
						} else {
							da_data.table_list.forEach((_da_data, _da_idnex) => {
								_da_data.forEach((_c_da_data, _c_da_idnex) => {
									if (_c_da_data.type == 'number') {
										if (_c_da_data.range) {
											document.querySelector(
													`.nested-table-wrapper_${index}`
												)
												.querySelector(
													`.form_item_${_c_da_data.type}_${_da_idnex}_${_c_da_idnex}`
												).querySelector(
													'.ant-input-number').style = ''

										}
									}

								})
							})
						}
					})

				})

			},
			// 切换品类之后调整样式
			changeStyle(arr) {
				if (this.is_limit) {
					let _form = this.form.getForm()
					let _form_data = _form.getFieldsValue()
					arr.forEach((data, index) => {
						data.forEach((da_data, da_index) => {
							if (da_data.type != 'table') {
								if (_form_data[`${da_data.type}_${index}_${da_index}`]) {
									if (da_data.range) {
										if (_form_data[`${da_data.type}_${index}_${da_index}`] >= da_data
											.range
											.min && _form_data[
												`${da_data.type}_${index}_${da_index}`] <= da_data.range
											.max) {
											document.querySelector(
													`.form_item_${da_data.type}_${index}_${da_index}`)
												.querySelector(
													'.ant-input-number').style = ''
										} else {
											document.querySelector(
													`.form_item_${da_data.type}_${index}_${da_index}`)
												.querySelector(
													'.ant-input-number').style =
												'border-color:orange !important;color:orange !important;'
										}
									}
								}
							} else {

								da_data.table_list.forEach((_da_data, _da_idnex) => {
									_da_data.forEach((_c_da_data, _c_da_idnex) => {
										if (_c_da_data.type == 'number') {
											if (_form_data[
													`${da_data.type}${da_index}${index}_input_${_c_da_data.type}_${_da_idnex}_${_c_da_idnex}`
												]) {
												if (_c_da_data.range) {
													if (_form_data[
															`${da_data.type}${da_index}${index}_input_${_c_da_data.type}_${_da_idnex}_${_c_da_idnex}`
														] >= _c_da_data.range.min &&
														_form_data[
															`${da_data.type}${da_index}${index}_input_${_c_da_data.type}_${_da_idnex}_${_c_da_idnex}`
														] <= _c_da_data.range.max) {

														document.querySelector(
																`.nested-table-wrapper_${index}`
															)
															.querySelector(
																`.form_item_${_c_da_data.type}_${_da_idnex}_${_c_da_idnex}`
															).querySelector(
																'.ant-input-number')
															.style = ''
													} else {

														document.querySelector(
																`.nested-table-wrapper_${index}`
															)
															.querySelector(
																`.form_item_${_c_da_data.type}_${_da_idnex}_${_c_da_idnex}`
															).querySelector(
																'.ant-input-number')
															.style =
															'border-color:orange !important;color:orange !important;'
													}

												}

											}
										}

									})
								})
							}
						})

					})
				}
			},
			// 数字框变化
			numberChaneg(e, item, index, data, da_index) {

				data.fun ? data.fun(e, this.form, item, index, data, da_index, this.table_list, this.add_flag) : () => {}
				if (this.is_limit) {
					if (this.filed.indexOf('table') < 0) {
						if (data.range) {
							console.log('e===', e === '')
							if (!e && e != 0 && e === '') {
								console.log('data', data)
								document.querySelector(`.form_item_${data.type}_${index}_${da_index}`).querySelector(
									'.ant-input-number').style = ''
								this.table_list[index][this.table_list[index].length - 1].rules = null
							} else {
								if (e >= data.range.min && e <= data.range.max) {
									document.querySelector(`.form_item_${data.type}_${index}_${da_index}`).querySelector(
										'.ant-input-number').style = ''
									this.table_list[index][this.table_list[index].length - 1].rules = null
								} else {
									document.querySelector(`.form_item_${data.type}_${index}_${da_index}`).querySelector(
											'.ant-input-number').style =
										'border-color:orange !important;color:orange !important;'

									// 阈值存在超过备注的必填

									this.table_list[index][this.table_list[index].length - 1].rules = [{
										"required": true,
										"message": "请输入"
									}]

								}
							}
						}
					} else {
						if (data.range) {
							if (!e && e != 0 && e == '') {
								document.querySelector(`.nested-table-wrapper_${this.cssindex}`).querySelector(
									`.form_item_${data.type}_${index}_${da_index}`).querySelector(
									'.ant-input-number').style = ''
								this.table_list[index][this.table_list[index].length - 1].rules = null
							} else {
								if (e >= data.range.min && e <= data.range.max) {
									document.querySelector(`.nested-table-wrapper_${this.cssindex}`).querySelector(
										`.form_item_${data.type}_${index}_${da_index}`).querySelector(
										'.ant-input-number').style = ''
									this.table_list[index][this.table_list[index].length - 1].rules = null
								} else {
									document.querySelector(`.nested-table-wrapper_${this.cssindex}`).querySelector(
											`.form_item_${data.type}_${index}_${da_index}`).querySelector(
											'.ant-input-number').style =
										'border-color:orange !important;color:orange !important;'
									this.table_list[index][this.table_list[index].length - 1].rules = [{
										"required": true,
										"message": "请输入"
									}]
								}
							}

						}
					}

				}
				// 调整下级必填
				if (data.change_next) {
					if (e && e != '' && e != 0) {
						this.p_table[this.cssindex + 2][da_index].rules = [{
							"required": true,
							"message": "请选择"
						}]
					} else {
						this.p_table[this.cssindex + 2][da_index].rules = []
						this.form.resetFields(`_select_${this.cssindex+2}_${da_index}`)
						this.$forceUpdate();
					}

				}
			},


		}
	}
</script>

<style scoped lang="less">
	.excelBox {
		margin: 0 auto;
		height: 100%;
		border-top: 2px solid #43464d;
	}

	.table_AgKOv {
		margin-top: -1px;
		border-left: 2px solid #2b2e33;
		border-right: 2px solid #2b2e33;
		border-bottom: 2px solid #2b2e33;
		table-layout: fixed;
		width: 100%;
		height: 100%;
		/* 添加这一行 */
	}

	table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	.table_AgKOv td,
	.table_AgKOv tr {
		border: 1px solid #2b2e33;
		position: relative;
	}

	.table_AgKOv td {
		height: 40px;
		line-height: 1.5;
		padding: 0 10px;
		text-align: center;
		vertical-align: middle;
		color: #2b2e33;
		box-sizing: border-box;
		/* 确保padding不会影响宽度计算 */
	}

	.table_AgKOv .value_1DtKU {
		text-align: left;
	}

	.label_3bK48 {
		font-weight: 700;
	}

	.value_1DtKU {}


	table th {
		font-weight: 700;
	}


	table td,
	table th {
		height: 38px;
		padding: 8px 12px;
		font-size: 16px;
		vertical-align: middle;
		word-break: break-all;
		border: 1px solid #495060;
	}


	table {
		width: 100%;
		border-color: #495060;
		border-style: solid;
		border-width: 1px 2px;
		border-collapse: collapse;
	}


	.table_AgKOv td[colspan="1"] {
		width: var(--cow--width);
	}

	.table_AgKOv td[colspan="1.5"] {
		width: calc(var(--cow--width) * 1.5);
	}

	.table_AgKOv td[colspan="2"] {
		width: calc(var(--cow--width) * 2);
	}

	.table_AgKOv td[colspan="3"] {
		width: calc(var(--cow--width) * 3);
	}

	.table_AgKOv td[colspan="4"] {
		width: calc(var(--cow--width) * 4);
	}

	.table_AgKOv td[colspan="5"] {
		width: calc(var(--cow--width) * 5);
	}

	.table_AgKOv td[colspan="6"] {
		width: calc(var(--cow--width) * 6);
	}

	.table_AgKOv td[colspan="7"] {
		width: calc(var(--cow--width) * 7);
	}

	.table_AgKOv td[colspan="8"] {
		width: calc(var(--cow--width) * 8);
	}

	.table_AgKOv td[colspan="9"] {
		width: calc(var(--cow--width) * 9);
	}

	.table_AgKOv td[colspan="10"] {
		width: calc(var(--cow--width) * 10);
	}

	.table_AgKOv td[colspan="11"] {
		width: calc(var(--cow--width) * 11);
	}

	.table_AgKOv td[colspan="12"] {
		width: calc(var(--cow--width) * 12);
	}

	.table_AgKOv td[colspan="13"] {
		width: calc(var(--cow--width) * 13);
	}

	.table_AgKOv td[colspan="14"] {
		width: calc(var(--cow--width) * 14);
	}

	.table_AgKOv td[colspan="15"] {
		width: calc(var(--cow--width) * 15);
	}

	.table_AgKOv td[colspan="16"] {
		width: calc(var(--cow--width) * 16);
	}

	.table_AgKOv td[colspan="17"] {
		width: calc(var(--cow--width) * 17);
	}

	.table_AgKOv td[colspan="18"] {
		width: calc(var(--cow--width) * 18);
	}

	.table_AgKOv td[colspan="19"] {
		width: calc(var(--cow--width) * 19);
	}

	.table_AgKOv td[colspan="20"] {
		width: calc(var(--cow--width) * 20);
	}

	.table_AgKOv td[colspan="21"] {
		width: calc(var(--cow--width) * 21);
	}

	.table_AgKOv td[colspan="22"] {
		width: calc(var(--cow--width) * 22);
	}

	.table_AgKOv td[colspan="23"] {
		width: calc(var(--cow--width) * 23);
	}

	.table_AgKOv td[colspan="24"] {
		width: calc(var(--cow--width) * 24);
	}

	.select_1DtKU {
		position: relative;

		img {
			width: 30px;
			height: 30px;
			position: absolute;
			right: -35px;
			top: 50%;
			transform: translateY(-50%);
		}

		.ant-form-item {
			::v-deep .ant-col {

				.ant-form-explain {
					display: inline-block;
				}

			}
		}

	}

	.select_box {
		.s_b_box {
			margin-bottom: 5px;
			width: 100%;

			.ant-select {
				width: 100%;
			}
		}

		.s_b_box:last-of-type {
			margin-bottom: 0;
		}
	}

	.ant-form-item {
		margin-bottom: 0;


		::v-deep .ant-col {

			.ant-form-explain {
				display: none;
			}

		}

		.ant-calendar-picker {
			width: 100%;
		}

		::v-deep .ant-select {
			.ant-select-selection__rendered {
				margin-right: 0 !important;
			}
		}
	}


	.flex_200 {
		display: flex;
		align-items: center;

		.ant-input {
			width: 200px;
		}

		.ant-calendar-picker {
			width: 200px;
		}
	}

	.ant-input-number {
		width: 100%;
	}

	.nested-table-cell {

		.nested-table-wrapper {
			width: 100%;
			height: 100%;
			// overflow: hidden;
			width: 100%; // 补偿左右各2px的边框
			position: relative;
			left: -1px;
		}

		::v-deep .excelBox {
			border-top: 0;
		}

		::v-deep .table_AgKOv {
			table-layout: auto !important;
			width: 100% !important;
			height: 100% !important;
			margin: 0 !important;
			// 移除内嵌表格的最外层边框
			border: none !important;

			td {
				// padding: 0 10px !important;
				box-sizing: border-box;
				height: auto;
			}

			// 第一排最左边td：去除上边框和左边框
			>tr {
				// border-top: none !important;
				border-left: none !important;
			}

			>tr>td:first-child {
				border-top: none !important;
				border-left: none !important;
			}

			// 第一排中间td：去除上边框
			>tr:first-child>td:not(:first-child):not(:last-child) {
				border-top: none !important;
				border-right: none !important;
			}

			// 第一排最右边td：去除上边框和右边框
			>tr:first-child {
				border-top: none !important;
				border-right: none !important;
			}

			>tr:first-child>td:last-child {
				border-top: none !important;
				border-right: none !important;
			}

			// 最后一排最左边td：去除下边框和左边框
			>tr:last-child> {
				border-bottom: none !important;
				border-left: none !important;
			}

			>tr:last-child>td:first-child {
				border-bottom: none !important;
				border-left: none !important;
			}

			// 最后一排中间td：去除下边框
			>tr>td:not(:first-child):not(:last-child) {
				border-bottom: none !important;
				border-right: none !important;
			}

			// 最后一排中间td：去除下边框
			>tr:last-child>td:not(:first-child):not(:last-child) {
				border-bottom: none !important;
				border-right: none !important;
			}

			// 最后一排最右边td：去除下边框和右边框
			>tr {
				border-bottom: none !important;
				border-right: none !important;
			}

			>tr>td:last-child {
				border-bottom: none !important;
				border-right: none !important;
			}

			// 保留其他内部单元格的边框
			td {
				border: 1px solid #2b2e33 !important;
			}
		}


	}

	.add_row_box {
		position: absolute;
		display: flex;
		align-items: center;
		gap: 12px;
		top: 50%;
		transform: translate(100%, -50%);
		right: -8px;

		img {
			width: 30px;
			height: 30px;
			cursor: pointer;
		}
	}

	.diagonal-cell {
		position: relative;
		overflow: hidden;
		padding: 0 !important;

		.diagonal-wrapper {
			position: relative;
			width: 100%;
			height: 100%;
		}

		.diagonal-content {
			position: relative;
			width: 100%;
			height: 100%;

			.diagonal-text {
				position: absolute;
				z-index: 2;
				font-size: 14px;
				line-height: 1.2;

				&.topLeft {
					top: 2px;
					left: 2px;
					right: 50%;
					bottom: 50%;
					display: flex;
					align-items: flex-start;
					justify-content: flex-start;
					padding: 2px;
				}

				&.bottomRight {
					top: 50%;
					left: 50%;
					right: 2px;
					bottom: 2px;
					display: flex;
					align-items: flex-end;
					justify-content: flex-end;
					padding: 2px;
				}

			}

		}

		.bottom-right {
			.topLeft {
				top: 50% !important;
				left: 2px;
				right: 50%;
				bottom: 2px !important;
				display: flex;
				align-items: flex-start;
				justify-content: flex-start;
				padding: 2px;
			}

			.bottomRight {
				top: 2px !important;
				left: 50%;
				right: 2px;
				bottom: 50% !important;
				display: flex;
				align-items: flex-end;
				justify-content: flex-end;
				padding: 2px;
			}
		}
	}

	.radio_square {
		::v-deep .ant-radio-inner {
			border-radius: 0;

			&::after {
				border-radius: 0;
			}
		}


	}


	.good_name_box {
		::v-deep .ant-select-selection--single {
			height: 60px;
			margin-bottom: 5px;
		}

		::v-deep .ant-select-selection-selected-value {
			overflow: auto;
			white-space: normal;
		}
	}

	::v-deep .ant-radio-disabled .ant-radio-inner::after {
		background-color: #1890ff;
	}

	.excel {
		::v-deep .table_AgKOv {
			width: 100% !important;
			height: auto !important;

		}

	}
</style>